/* eslint-disable */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import * as api from '../../epics/api';

const propTypes = {
    strikes: PropTypes.object.isRequired,
};

class FreelancerDetailsStrikes extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isDeleting: null,
        };
    }

    handleDeleteButtonClick = (id, url) => {
        this.setState({ isDeleting: id });
        api.executeHttpRequest(url, 'DELETE', null, false)
            .then(res => {
                this.props.fetchListOf(
                    'strikes',
                    `freelancers/${this.props.freelancerData.id}/strikes/`,
                );
                this.setState({ isDeleting: null });
            })
            .catch(function (err) {
                this.setState({ isDeleting: null });
            });
    };

    renderRows() {
        const strikes = this.props.strikes.content;
        const { editionEnabled } = this.props;
        return strikes.map((strike, index) => (
            <tr key={index}>
                <td>{moment(strike.created).format('DD/MM/YYYY')}</td>
                <td>BK{strike.booking}</td>
                <td>&times;{strike.weight}</td>
                <td>
                    {strike.label}
                    {strike.comment ? (
                        <span className="italic">
                            <br />
                            {strike.comment}
                        </span>
                    ) : null}
                </td>
                {editionEnabled ? (
                    <td className="actions center">
                        <button
                            disabled={
                                this.state.isDeleting == strike.id ||
                                !strike.delete_endpoint
                            }
                            onClick={() =>
                                this.handleDeleteButtonClick(
                                    strike.id,
                                    strike.delete_endpoint,
                                )
                            }
                        >
                            <i className="icon icon-bin-1" />
                        </button>
                    </td>
                ) : null}
            </tr>
        ));
    }

    render() {
        const { editionEnabled } = this.props;
        return (
            <div className="freelancer-details-section">
                <div className="freelancer-details-section__header">
                    <div className="freelancer-details-section__title">
                        Strikes
                    </div>
                    {this.props.strikes.loading ? (
                        <i className="icon icon-loading-1 font-size-30" />
                    ) : null}
                </div>
                <div className="freelancer-details-section__content">
                    <table className="table-default">
                        <tbody>
                            <tr>
                                <td className="table-default__cell--text-blue">
                                    Date
                                </td>
                                <td className="table-default__cell--text-blue">
                                    Booking
                                </td>
                                <td className="table-default__cell--text-blue">
                                    Weight
                                </td>
                                <td className="table-default__cell--text-blue">
                                    Details
                                </td>
                                {editionEnabled ? (
                                    <td className="table-default__cell--text-blue center" />
                                ) : null}
                            </tr>
                            {this.renderRows()}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}

FreelancerDetailsStrikes.propTypes = propTypes;

export default FreelancerDetailsStrikes;
